'use strict';

var module = angular.module('app');

module.directive('vertilizeContainer', function ($timeout, $window) {
        return {
            restrict: 'EA',
            controller: function ($timeout) {

                var self = this;

                this.style = {
                    min: 0
                };

                this.childs = [];

                this.timer = null;

                this.setHeights = function()
                {
                    if (self.timer) {
                        $timeout.cancel(this.timer);
                    }

                    self.timer = $timeout(function()
                    {
                        var tallest = 0;

                        angular.forEach(self.childs, function(child)
                        {
                            child.removeStyle();

                            if (child.getHeight() > tallest) {
                                tallest = child.getHeight();
                            }
                        });

                        self.style.min = tallest + 1;
                    }, 500);
                };

                this.setHeights();

                angular.element($window).bind('resize', function()
                {
                    self.style.min = 0;
                    self.setHeights();
                });

                var init = function()
                {
                    // Trigger the resize handler so we can execute setHeights() on page load
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize')
                    }, 1500);
                };

                init();
            }
        };
    });

module.directive('vertilize', function ()
    {
        return {
            restrict: 'EA',
            require: '^^vertilizeContainer',
            link: function (scope, element, attrs, parent) {

                scope.style = parent.style;

                if (parent.childs.indexOf(scope) < 0) {
                    parent.childs.push(scope);
                }

                scope.getHeight = function(){
                    return  element[0].clientHeight;
                };

                scope.removeStyle = function()
                {
                   var inner = element[0].getElementsByClassName('col-inner')[0];

                   if (inner) {
                       inner.minHeight = 0;
                   }
                }
            }
        };
    }
);
